import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { t } from "i18next";
import { Button, Flex } from "antd";
import { ModalVertFixed } from "src/components/ModalVertFixed";
import { DeleteOutlined, UndoOutlined } from "@ant-design/icons";
import { SchedulingControlStore } from "../../SchedulingControlStore";
import styles from "./SchedDelToolbar.module.less";
import { DeletionInfoTable } from "./DeletionInfoTable";

interface PropsSchedDelToolbar {
  store: SchedulingControlStore;
}

export const SchedDelToolbar: React.FC<PropsSchedDelToolbar> = observer(
  ({ store }) => {
    const { selectedTaskIds, operationLoading } = store;
    const [open, setOpen] = useState(false);
    return (
      <>
        <div className={styles.container}>
          <Flex align="center" gap={8}>
            {t(
              "The deletion will affect scheduled task dates, due to the deletion of task bindings.",
            )}
            <button
              type="button"
              className={styles.delInfoButton}
              onClick={() => setOpen(true)}
            >
              {t("Tasks selected for deletion")}: {selectedTaskIds.length}
            </button>
          </Flex>
          <Flex gap={8} align="center">
            <Button
              icon={<UndoOutlined />}
              onClick={() => store.cancelDeletion()}
              disabled={operationLoading}
            >
              {t("Cancel")}
            </Button>
            <Button
              icon={<DeleteOutlined />}
              onClick={() => store.doDelete()}
              loading={operationLoading}
              className={styles.confirmButton}
            >
              {t("Confirm deletion")}
            </Button>
          </Flex>
        </div>
        <ModalVertFixed
          width={860}
          open={open}
          onCancel={() => setOpen(false)}
          title={t("Deletion of tasks")}
          footer={null}
        >
          <DeletionInfoTable store={store} />
        </ModalVertFixed>
      </>
    );
  },
);
